exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#messages{position:absolute;height:100%;width:100%;top:0;left:0;overflow-y:scroll;z-index:10;background:rgba(0,0,0,.75)}#messages li{list-style:none}#messages li.empty{text-align:center;padding:24px 6px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-rewriter.js?id=data-v-8e1a7040!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MessagesList.vue
// module id = 54
// module chunks = 0